import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate, useParams } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import dashboardIcon from "../../../assets/themeIcons/dashboard.svg";
import businessIcon from "../../../assets/themeIcons/business.svg";
import consumersIcon from "../../../assets/themeIcons/consumers.svg";
import brandingIcon from "../../../assets/themeIcons/branding.svg";
import plansIcon from "../../../assets/themeIcons/plans.svg";
import settingsIcon from "../../../assets/themeIcons/settings.svg";
import helpIcon from "../../../assets/themeIcons/help.svg";
import previewIcon from "../../../assets/themeIcons/preview.svg";
import MDModal from "components/MDModal";
import { IoIosNotifications } from "react-icons/io";
import { FaExchangeAlt } from "react-icons/fa";

const AppNav = () => {
  const navigate = useNavigate();
  const { email, locationId } = useParams();
  const [agency, Update] = useAgencyInfo();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [notification, SetNotification] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [cannyAppId, setCannyAppId] = useState("");
  const AppService = useAppServices();
  const currentCompanyId = agency?.ghl?.location_id;

  const handleNotification = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const getNotification = async () => {
    const { response } = await AppService.notification.get();

    if (response) {
      SetNotification(response.data);
    }
  };

  useEffect(() => {
    getNotification();
  }, []);

  const UnReadNotifications = notification?.filter((n) => !n.readBy?.includes(currentCompanyId));

  const handleRead = async (notification) => {
    setSidebarOpen(false);
    setSelectedNotification(notification);
    setModalOpen(true);
    const payload = {
      _id: notification._id,
      readBy: [agency?.ghl?.location_id],
    };

    const { response } = await AppService.notification.read({ payload });

    if (response) {
      getNotification();
    }
  };

  // State to store the iframe URL

  // Function to dynamically update iframe URL
  const handleRoutes = (page) => {
    const newIframeUrl = `/${email}/${locationId}/${page}`;
    navigate(newIframeUrl);
  };

  const handleRedirect = () => {
    if (agency?.domain) {
      let formattedUrl = agency.domain.trim(); // Remove extra spaces

      if (!formattedUrl.startsWith("http://") && !formattedUrl.startsWith("https://")) {
        formattedUrl = `https://${formattedUrl}`;
      }

      window.open(formattedUrl, "_blank");
    } else {
      // alert("No valid URL found in agency data.");
      let formattedUrl = `https://preview.easyaidirectory.com/app/${agency._id}`;

      window.open(formattedUrl, "_blank");
    }
  };

  const redirectToHelpCenter = () => {
    let formattedUrl = `https://smartdirectory.ai/help`;
    window.open(formattedUrl, "_blank");
  };

  const GetSuperAdminSetting = async () => {
    const { response } = await AppService.superadmin.GET();
    if (response) {
      setCannyAppId(response?.data?.canny_app_id || "");
    }
  }

  useEffect(() => {
    GetSuperAdminSetting()
  }, [])

  Canny("initChangelog", {
    appID: cannyAppId,
    position: "bottom",
    align: "left",
    theme: "light",
  });

  return (
    <>
      <nav className="navbar" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
        <div className="navbar-logo"></div>
        <ul className="navbar-links">
          <li>
            <span onClick={() => handleRoutes("dashboard")}>
              <img style={{ verticalAlign: "sub" }} src={dashboardIcon} /> Dashboard
            </span>
          </li>
          <li>
            <span onClick={() => handleRoutes("accounts")}>
              <img style={{ verticalAlign: "sub" }} src={businessIcon} /> Businesses
            </span>
          </li>
          <li>
            <span onClick={() => handleRoutes("submissions")}>
              <img style={{ verticalAlign: "sub" }} src={businessIcon} /> Submissions
            </span>
          </li>
          <li>
            <span onClick={() => handleRoutes("consumers")}>
              <img style={{ verticalAlign: "sub" }} src={consumersIcon} /> Consumers
            </span>
          </li>
          <li>
            <span onClick={() => handleRoutes("settings/branding")}>
              <img style={{ verticalAlign: "sub" }} src={brandingIcon} /> Branding
            </span>
          </li>
          <li>
            <span onClick={() => handleRoutes("saas")}>
              <img style={{ verticalAlign: "sub" }} src={plansIcon} /> Plans
            </span>
          </li>
          <li>
            <span onClick={() => handleRoutes("settings/integration")}>
              <img style={{ verticalAlign: "sub" }} src={settingsIcon} /> Settings
            </span>
          </li>
          <li>
            <span data-canny-changelog>
              <FaExchangeAlt />Changelogs
            </span>
          </li>
          <li>
            <span onClick={redirectToHelpCenter}>
              <img style={{ verticalAlign: "sub" }} src={helpIcon} /> Help
            </span>
          </li>
          <li>
            <span
              onClick={handleNotification}
              style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}
            >
              <IoIosNotifications size={25} style={{ color: "#353535" }} />
              <span style={{ fontWeight: 500, color: "#353535" }}>Notification</span>

              {UnReadNotifications?.length > 0 && (
                <span
                  style={{
                    backgroundColor: "red",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    color: "white",
                    fontSize: "12px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "20px",
                  }}
                >
                  {UnReadNotifications.length}
                </span>
              )}
            </span>
          </li>

          <li>
            <span onClick={handleRedirect}>
              <span style={{ textDecoration: "underline" }}>Preview</span>{" "}
              <img style={{ verticalAlign: "middle", width: "30px" }} src={previewIcon} />
            </span>
          </li>
        </ul>
      </nav>
      <div className={`notification-sidebar ${isSidebarOpen ? "active" : ""}`}>
        <div className="notification-header">
          <h4 style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0 }}>
            Notifications
            {UnReadNotifications?.length > 0 && (
              <span
                style={{
                  backgroundColor: "red",
                  padding: "2px 8px",
                  borderRadius: "12px",
                  color: "white",
                  fontSize: "13px",
                  height: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "20px",
                }}
              >
                {UnReadNotifications.length}
              </span>
            )}
          </h4>

          <button
            onClick={closeSidebar}
            style={{
              cursor: "pointer",
              height: "30px",
              width: "30px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
              border: "none",
            }}
          >
            x
          </button>
        </div>
        <div className="notification-body">
          {notification?.length > 0 ? (
            <>
              {notification.map((n, index) => (
                <div
                  onClick={() => handleRead(n)}
                  key={index}
                  style={{
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 10px",
                    marginBottom: "10px",
                    backgroundColor: `${!n.readBy.includes(currentCompanyId) ? "#ebfbfd" : "white"
                      }`,
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                    cursor: "pointer",
                  }}
                >
                  <p style={{ margin: 0, color: "black", fontSize: "14px", fontWeight: 500 }}>
                    {n.title}
                  </p>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "gray",
                      margin: 0,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    dangerouslySetInnerHTML={{ __html: n.message }}
                  ></p>

                  <p style={{ fontSize: "11px", color: "black", marginTop: "5px" }}>
                    {new Date(n.createdAt).toLocaleString()}
                  </p>
                </div>
              ))}
            </>
          ) : (
            <p>No New Notification Found</p>
          )}
        </div>
      </div>

      {modalOpen && selectedNotification && (
        <MDModal open={modalOpen} onClose={() => setModalOpen(false)} width={700}>
          <div style={{ padding: "5px 10px" }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#333",
                  color: "white",
                  width: "35px",
                  height: "35px",
                  border: "none",
                  borderRadius: "50%",
                  cursor: "pointer",
                  fontSize: "18px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#555")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#333")}
                aria-label="Close"
                title="Close"
              >
                ×
              </button>
            </div>

            <h3 style={{ marginBottom: "10px" }}>{selectedNotification.title}</h3>
            <p
              style={{
                fontSize: "17px",

                margin: 0,
              }}
              dangerouslySetInnerHTML={{ __html: selectedNotification.message }}
            ></p>
          </div>
        </MDModal>
      )}
    </>
  );
};

export default AppNav;
